<script lang="ts">
    import { Dot, RadioGroup } from "attractions";
    import { onMount } from "svelte";
    import { CURRENT_PURCHASE_PAYMENT, CURRENT_PURCHASE_PRODUCT } from "../../Stores/Purchase";   
    import Currency from "../../Utils/Currency";

    const paymentOptions = [
        { value: 'true', label: "Płacę teraz" },
        { value: 'false', label: "Zapłacę później" }
    ];

    let currentPurchase;
    let payNow: boolean = true;

    CURRENT_PURCHASE_PRODUCT.subscribe(data => {
        currentPurchase = data;
        if (currentPurchase.price - (currentPurchase.price * (currentPurchase.discount / 100)) == 0) CURRENT_PURCHASE_PAYMENT.set(true);
        else CURRENT_PURCHASE_PAYMENT.set(null);
    });

    function handleChangePaymentState(e) {
        payNow = e.detail.value;
        CURRENT_PURCHASE_PAYMENT.set(payNow);
    }
</script>

{#if currentPurchase.value}
    <section class="purchasePrice">
        <small class="summaryLabel">PODSUMOWANIE</small>
        {#if currentPurchase.discount !== 0}
            <small class="priceBeforeDiscount">{Currency.format(currentPurchase.price)}</small>
        {/if}
        <h3 class="priceAfterDiscount">{Currency.format(currentPurchase.price - (currentPurchase.price * (currentPurchase.discount / 100)))}</h3>
        <small class="employeeDiscountLabel">
            {#if currentPurchase.discount !== 0}
                Powyższa kwota uwzględnia przyznany Ci rabat pracowniczy w wysokości {currentPurchase.discount}%.
            {:else}
                Wybrany produkt nie jest objęty programem zniżek pracowniczych.
            {/if}
        </small>
        <div class="purchasePayment">
            <small class="summaryLabel">PŁATNOŚĆ</small>
            {#if currentPurchase.price - (currentPurchase.price * (currentPurchase.discount / 100)) !== 0}
                <RadioGroup on:change={handleChangePaymentState} items={paymentOptions} class="radioGroup" radioClass="radioLabel" labelClass="radioLabel" />
            {:else}
                <div class="notRequired">
                    <Dot info />
                    <small class="switchLabel">Ten zakup nie wymaga płatności.</small>
                </div>
            {/if}
        </div>
    </section>
{/if}

<style type="text/scss">
    .purchasePrice {
        display: flex;
        flex-direction: column;
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid gray;

        .priceAfterDiscount,
        .priceBeforeDiscount {
            margin-top: .2rem;
        }

        .summaryLabel {
            display: block;
            color: gray;
            font-size: 0.75rem;
        }

        .priceBeforeDiscount {
            font-size: .75rem;
            color: red;
            text-decoration: line-through;
        }

        .employeeDiscountLabel {
            margin: .5rem 0;
            color: gray;
            font-size: .5rem;
        }

        .purchasePayment {
            .summaryLabel {
                margin-bottom: .25rem;
            }

            .switchLabel {
                font-size: .85rem;
                margin-left: .25rem;
                color: gray;

                &.active {
                    color: #4300b0;
                }
            }

            .notRequired {
                display: flex;
                align-items: center;
                margin: .25rem 0;
            }
        }
    }
</style>